import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import CtaButton from "./CtaButton";

const LINKS = [
  { label: "Overview", href: "#overview", id: "nav-overview-link" },
  { label: "Features", href: "#features", id: "nav-features-link" },
  { label: "Tutorial", href: "#tutorial", id: "nav-tutorial-link" },
  { label: "FAQ", href: "#faq", id: "nav-faq-link" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 border-b ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-white/10" : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-[72px]">
          <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5 group">
            <span className="h-6 w-6 bg-white flex items-center justify-center">
              <span className="h-2.5 w-2.5 bg-black" />
            </span>
            <span className="font-display text-lg font-semibold tracking-tight text-white">
              ROLL<span className="text-cyan-400">.</span>OPS
            </span>
            <span className="hidden sm:inline-block ml-2 px-2 py-0.5 text-[10px] font-mono uppercase tracking-[0.18em] text-cyan-300 border border-cyan-400/30 bg-cyan-400/5">
              Tutorial
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={l.id}
                className="text-sm text-zinc-400 hover:text-white transition-colors duration-200"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <CtaButton
              ctaId="nav-open-app-cta"
              label="Open ROLL.OPS"
              location="navbar"
              className="px-5 py-2.5"
            >
              Open ROLL.OPS
            </CtaButton>
          </div>

          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden text-white p-2"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 flex flex-col gap-5"
        >
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`mobile-${l.id}`}
              onClick={() => setOpen(false)}
              className="text-base text-zinc-300 hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
          <CtaButton
            ctaId="mobile-open-app-cta"
            label="Open ROLL.OPS"
            location="mobile-nav"
            className="w-full mt-2"
          >
            Open ROLL.OPS
          </CtaButton>
        </div>
      )}
    </header>
  );
};

export default Navbar;
